document.addEventListener("DOMContentLoaded", () => {


// KH Slide Product – Swiper + truncation + single modal
(function () {
  function onReady(fn){ document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', fn) : fn(); }

  function truncateText(src, maxWords, maxChars){
    const clean = (src || '').trim().replace(/\s+/g, ' ');
    const words = clean.split(' ');
    const byWords = words.length > maxWords ? words.slice(0, maxWords).join(' ') : clean;
    const byChars = clean.length > maxChars ? clean.slice(0, maxChars) : clean;
    const chosen = byWords.length <= byChars.length ? byWords : byChars;
    const needsMore = clean.length > chosen.length || words.length > maxWords;
    return { text: needsMore ? chosen.replace(/[ .,;:!?-]*$/,'') + '…' : chosen, truncated: needsMore, full: clean };
  }


  //MODALE SLIDER PRODUCT
// ---- initModal (sostituire la versione esistente) ----
function initModal(section){
  const modal   = section.querySelector('.sp-modal-overlay');
  if(!modal) return;
  const imgEl   = modal.querySelector('.sp-modal__img');
  const titleEl = modal.querySelector('.sp-modal__title');
  const descEl  = modal.querySelector('.sp-modal__desc');
  const btnClose= modal.querySelector('.sp-modal__close');

  // helper: decode HTML entities (es. &lt;br&gt;, &amp;, &#10;, etc.)
  function decodeEntities(input){
    if(!input) return '';
    // create a textarea to decode HTML entities
    const txt = document.createElement('textarea');
    txt.innerHTML = input;
    return txt.value;
  }

  function open(payload){
    // immagine
    if(payload.img){
      imgEl.src = payload.img;
      imgEl.alt = payload.title || '';
      imgEl.parentElement.style.display = 'flex';
    } else {
      imgEl.src = '';
      imgEl.alt = '';
      imgEl.parentElement.style.display = 'none';
    }

    // titolo
    titleEl.textContent = payload.title || '';

    // descrizione: supporta HTML già presente o testo con newline
    let raw = String(payload.desc || '');

    // 1) decodifica eventuali entità html (&lt;br&gt; etc)
    let decoded = decodeEntities(raw);

    // 2) se il dataset è stato passato con sequenze di backslash-n (es. "\n") -> convertile in newline reale
    decoded = decoded.replace(/\\n/g, '\n');

    // 3) normalizza CRLF / CR
    decoded = decoded.replace(/\r\n/g, '\n').replace(/\r/g, '\n');

    // 4) rileva se il contenuto contiene tag HTML (p, br, li ecc.)
    const hasHTML = /<\/?[a-z][\s\S]*>/i.test(decoded);

    if (hasHTML) {
      // Contiene tag HTML: mantieni l'HTML ma normalizza eccessi di newline
      // Nota: lasciamo i tag così come sono (preserva <p> e <br>)
      // Rimuoviamo newline multipli e li riduciamo a due per evitare righe vuote eccessive
      const normalized = decoded.replace(/\n{3,}/g, '\n\n');
      descEl.innerHTML = normalized;
    } else {
      // Testo semplice: converti newline in <br> e usa innerHTML
      const html = decoded
        .split('\n')
        .map(s => s.trim())
        .join('<br>');
      descEl.innerHTML = html;
    }

    // Assicuriamoci che la modale rispetti newline anche come testo (fallback)
    descEl.style.whiteSpace = 'pre-line';

    // apri modale
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    btnClose && btnClose.focus();
  }

  function close(){
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  modal.addEventListener('click', (e)=>{ if(e.target === modal) close(); });
  btnClose && btnClose.addEventListener('click', close);
  document.addEventListener('keydown', (e)=>{ if(modal.getAttribute('aria-hidden')==='false' && e.key === 'Escape') close(); });

  return { open, close };
}



  function prepareCards(section, modalApi){
    section.querySelectorAll('.sp-card').forEach((card)=>{
      const p = card.querySelector('.sp-desc');
      const btn = card.querySelector('.sp-readmore');
      if(!p) return;

      const maxWords = Number(p.dataset.maxWords || 50);
      const maxChars = Number(p.dataset.maxChars || 270);
      const fullText = card.dataset.desc || '';
      const res = truncateText(fullText, maxWords, maxChars);
      p.textContent = res.text;

      if(res.truncated && btn){
        btn.hidden = false;
        btn.addEventListener('click', ()=>{
          modalApi.open({
            img: card.dataset.img || '',
            title: card.dataset.title || '',
            desc: card.dataset.desc || ''
          });
        });
      } else if(btn) {
        btn.hidden = true;
      }
    });
  }

  function initSwiperSection(section){
    const viewport = section.querySelector('.sp-viewport');
    const container = section.querySelector('.sp-swiper');
    const prevEl = section.querySelector('.sp-prev');
    const nextEl = section.querySelector('.sp-next');
    if (!viewport || !container) return;

    const visible = Number(section.dataset.visible || 3);
    const gap = Number(section.dataset.gap || 16);
    const peek = Number(section.dataset.peek || 40);

    if (peek > 0) {
      viewport.style.setProperty('--peek', `${peek}px`);
      viewport.classList.add('has-peek');
    }

    const swiper = new Swiper(container, {
      slidesPerView: Math.max(1, visible),
      spaceBetween: gap,
      slidesOffsetAfter: peek,
      loop: false,
      a11y: { enabled: true },
      keyboard: { enabled: true, onlyInViewport: true },
      navigation: (prevEl && nextEl) ? { prevEl, nextEl } : false,
      breakpoints: {
        0:   { slidesPerView: 1.1, spaceBetween: gap, slidesOffsetAfter: peek },
        640: { slidesPerView: 2,   spaceBetween: gap, slidesOffsetAfter: peek },
        1024:{ slidesPerView: Math.max(1, visible), spaceBetween: gap, slidesOffsetAfter: peek }
      }
    });

    window.addEventListener('resize', () => {
      swiper.params.spaceBetween = gap;
      swiper.params.slidesOffsetAfter = peek;
      swiper.update();
    });
  }

  onReady(function(){
    const boot = () => {
      if (typeof window.Swiper === 'undefined') { setTimeout(boot, 50); return; }
      document.querySelectorAll('.sp-section').forEach((section)=>{
        const modalApi = initModal(section);
        if(modalApi) prepareCards(section, modalApi);
        initSwiperSection(section);
      });
    };
    boot();
  });
})();


// ---------- TABS (senza Liquid, multi-sezione) ----------
(function tabsBoot() {
  // Trova tutti i contenitori tabs. Preferisci data-tabs-root se lo aggiungi.
  var roots = document.querySelectorAll('[data-tabs-root], [id^="tabs-"]');
  if (!roots.length) return;

  roots.forEach(function initTabs(root) {
    var buttons = root.querySelectorAll('[data-tab]');
    var panels  = root.querySelectorAll('[data-panel]');
    if (!buttons.length || !panels.length) return;

    function getPanel(index) {
      return Array.prototype.find.call(panels, function (p) {
        return p.getAttribute('data-panel') === index;
      });
    }

    function slideDown(el) {
      if (!el) return;
      if (!el.hidden && el.dataset.state === 'open') return;
      el.hidden = false;
      el.dataset.state = 'open';
      el.style.overflow = 'hidden';
      el.style.height = '0px';
      el.style.opacity = '0';
      el.style.transition = 'height 200ms ease, opacity 200ms ease';
      var h = el.scrollHeight;
      el.getBoundingClientRect(); // reflow
      el.style.height = h + 'px';
      el.style.opacity = '1';
      el.classList.add('active');
      el.addEventListener('transitionend', function cleanup(e) {
        if (e.target !== el) return;
        el.style.height = '';
        el.style.overflow = '';
        el.style.transition = '';
        el.removeEventListener('transitionend', cleanup);
      });
    }

    function slideUp(el) {
      if (!el || el.hidden) return;
      el.dataset.state = 'closed';
      el.style.overflow = 'hidden';
      el.style.height = el.scrollHeight + 'px';
      el.style.opacity = '1';
      el.style.transition = 'height 200ms ease, opacity 200ms ease';
      el.getBoundingClientRect(); // reflow
      el.style.height = '0px';
      el.style.opacity = '0';
      el.addEventListener('transitionend', function cleanup(e) {
        if (e.target !== el) return;
        el.hidden = true;
        el.classList.remove('active');
        el.style.height = '';
        el.style.overflow = '';
        el.style.transition = '';
        el.removeEventListener('transitionend', cleanup);
      });
    }

    function activate(index, toggleIfActive) {
      var targetPanel = getPanel(index);
      if (!targetPanel) return;

      buttons.forEach(function (b) {
        var isActive = b.getAttribute('data-tab') === index;
        b.classList.toggle('active', isActive);
        b.setAttribute('aria-expanded', isActive ? 'true' : 'false');
      });

      panels.forEach(function (p) {
        if (p === targetPanel) return;
        slideUp(p);
      });

      if (toggleIfActive) {
        if (targetPanel.hidden) slideDown(targetPanel);
        else slideUp(targetPanel);
      } else {
        slideDown(targetPanel);
      }
    }

    // Click
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var index = btn.getAttribute('data-tab');
        var panel = getPanel(index);
        var isAlreadyActive = btn.classList.contains('active') && panel && !panel.hidden;
        activate(index, isAlreadyActive);
      });
    });

    // Stato iniziale: se c'è un bottone già .active lo uso, altrimenti il primo
    var initial =
      (Array.prototype.find.call(buttons, function (b) { return b.classList.contains('active'); }) || buttons[0]);
    var firstIndex = initial && initial.getAttribute('data-tab');

    // Nascondi tutto prima di aprire quello iniziale (evita flash)
    panels.forEach(function (p) {
      if (!p.hidden) { p.hidden = true; }
      p.dataset.state = 'closed';
    });

    if (firstIndex != null) activate(firstIndex, false);
  });
})();



// ---------- KH COLLECTIONS PAGE (solo immagine + titolo) ----------
function initKHCollectionsSection(section) {
  if (!section || !section.classList.contains('kh-collections-page')) return;

  const viewport = section.querySelector('.khc-viewport');
  const container = section.querySelector('.khc-swiper');

  if (!viewport || !container) return;

  const gap  = 16;
  const peek = Number(section.getAttribute('data-peek') || 40);

  // Applica peek
  if (peek > 0) {
    viewport.style.setProperty('--peek', `${peek}px`);
    viewport.classList.add('has-peek');
  }

  const swiper = new Swiper(container, {
    slidesPerView: 3,
    spaceBetween: gap,
    slidesOffsetAfter: peek,

    a11y: { enabled: true },
    keyboard: { enabled: true, onlyInViewport: true },

    loop: true,
    observeParents: true,
    observer: true,

    breakpoints: {
      0:    { slidesPerView: 1,   spaceBetween: gap, slidesOffsetAfter: peek },
      720:  { slidesPerView: 2,   spaceBetween: gap, slidesOffsetAfter: peek },
      1024: { slidesPerView: 3,   spaceBetween: gap, slidesOffsetAfter: peek }
    }
  });

  window.addEventListener('resize', () => {
    swiper.params.spaceBetween = gap;
    swiper.params.slidesOffsetAfter = peek;
    swiper.update();
  });
}

(function bootKHCollections() {
  const tryInit = () => {
    if (typeof window.Swiper === 'undefined') {
      setTimeout(tryInit, 50);
      return;
    }
    document.querySelectorAll('.kh-collections-page').forEach(initKHCollectionsSection);
  };
  tryInit();
})();

(function(){
  function openModal(modal){
    if(!modal) return;
    modal.setAttribute('aria-hidden','false');
    document.documentElement.style.overflow = 'hidden';
    var first = modal.querySelector('input,textarea,select,button,[href]');
    if(first) first.focus({preventScroll:true});
  }
  function closeModal(modal){
    if(!modal) return;
    modal.setAttribute('aria-hidden','true');
    document.documentElement.style.overflow = '';
  }
  function getModalById(id){
    return document.querySelector('.khc-overlay[data-khc-modal="'+ id +'"]');
  }

  // Delegato: apre qualsiasi elemento con data-khc-open
  function onClick(e){
    var trigger = e.target.closest('[data-khc-open]');
    if(trigger){
      e.preventDefault();
      var id = trigger.getAttribute('data-khc-open') || 'promo-consulenza';
      var modal = getModalById(id);
      openModal(modal);
      return;
    }
    // chiusura per [data-khc-close]
    if(e.target.closest('[data-khc-close]')){
      var m = e.target.closest('.khc-overlay');
      closeModal(m);
      return;
    }
    // click su overlay (fuori dialog)
    if(e.target.classList && e.target.classList.contains('khc-overlay')){
      closeModal(e.target);
    }
  }

  // ESC chiude
  function onKey(e){
    if(e.key === 'Escape'){
      document.querySelectorAll('.khc-overlay[aria-hidden="false"]').forEach(closeModal);
    }
  }

  // (ri)aggancia gli handler — utile se il tema usa AJAX navigation / section reload
  function bind(){
    // Evita doppi binding
    if(!document.__khc_bound){
      document.addEventListener('click', onClick);
      document.addEventListener('keydown', onKey);
      document.__khc_bound = true;
    }
  }

  // Bind iniziale
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', bind);
  }else{
    bind();
  }

  // Eventi comuni nei temi per reload dinamici
  ['shopify:section:load','page:load','swup:contentReplaced','turbo:load','pjax:complete'].forEach(function(ev){
    document.addEventListener(ev, bind);
  });
})();




//MENU COLLEZIONI CORRELATE
(function () {
  const FLAG = 'khRelCollInited';

  function normalizePath(url) {
    try {
      const u = new URL(url, window.location.origin);
      let p = u.pathname;
      if (p.endsWith('/')) p = p.slice(0, -1);
      return p.toLowerCase();
    } catch (e) {
      return String(url || '').toLowerCase().replace(/\/$/, '');
    }
  }

  // Marca corrente:
  // - se data-first-current="true" => prima voce è corrente (no match URL)
  // - altrimenti match per URL
  function markCurrent(root) {
    const forceFirst = root.dataset.firstCurrent === 'true';

    root.querySelectorAll('.kh-rc-card').forEach((a) => {
      a.classList.remove('is-current');
      a.removeAttribute('aria-current');
    });

    if (forceFirst) {
      const first = root.querySelector('.kh-rc-card');
      if (first) {
        first.classList.add('is-current');
        first.setAttribute('aria-current', 'page');
      }
      return;
    }

    const currentPath = normalizePath(window.location.pathname);
    root.querySelectorAll('.kh-rc-card[href]').forEach((a) => {
      const hrefPath = normalizePath(a.getAttribute('href'));
      if (hrefPath && hrefPath === currentPath) {
        a.classList.add('is-current');
        a.setAttribute('aria-current', 'page');
      }
    });
  }

  function disableCurrentIfNeeded(root) {
    if (root.dataset.disableCurrent !== 'true') return;
    const current = root.querySelector('.kh-rc-card.is-current');
    if (!current) return;
    current.classList.add('is-disabled');
    current.setAttribute('aria-disabled', 'true');
    current.setAttribute('tabindex', '-1');
    if (current.tagName === 'A') current.removeAttribute('href');
  }

  function updateArrows(swiper, root) {
    const prev = root.querySelector('.kh-rc-prev');
    const next = root.querySelector('.kh-rc-next');
    if (!prev || !next) return;

    if (swiper.isLocked) {
      prev.classList.remove('is-visible');
      next.classList.remove('is-visible');
      return;
    }
    if (swiper.params.loop) {
      prev.classList.add('is-visible');
      next.classList.add('is-visible');
      return;
    }
    if (swiper.isBeginning) prev.classList.remove('is-visible'); else prev.classList.add('is-visible');
    if (swiper.isEnd)       next.classList.remove('is-visible'); else next.classList.add('is-visible');
  }

  function initOne(root) {
    if (!root || root[FLAG]) return;
    const swiperEl = root.querySelector('.kh-rc-swiper');
    if (!swiperEl || typeof Swiper === 'undefined') return;

    const space = Number(root.dataset.space || 12);
    const loop = root.dataset.loop === 'true';
    const autoplay = root.dataset.autoplay === 'true';
    const centered = root.dataset.center === 'true';
    const freeMode = root.dataset.freeMode === 'true';

    const config = {
      slidesPerView: 1.6,
      spaceBetween: Math.max(6, Math.min(space, 16)),
      centeredSlides: centered,
      loop: loop,
      freeMode: freeMode,
      watchOverflow: true,
      a11y: true,
      keyboard: { enabled: true },
      mousewheel: { forceToAxis: true, releaseOnEdges: true },
      breakpoints: {
        768: { slidesPerView: 2.6, spaceBetween: space, centeredSlides:true },
        1024: { slidesPerView: 4.2, spaceBetween: space },
      }
    };

    const prev = root.querySelector('.kh-rc-prev');
    const next = root.querySelector('.kh-rc-next');
    if (prev && next) config.navigation = { prevEl: prev, nextEl: next };

    const pagination = root.querySelector('.kh-rc-pagination');
    if (pagination) config.pagination = { el: pagination, clickable: true };

    if (autoplay) config.autoplay = { delay: 3000, disableOnInteraction: false };

    const swiper = new Swiper(swiperEl, config);

    markCurrent(root);
    disableCurrentIfNeeded(root);

    const boundUpdate = () => updateArrows(swiper, root);
    swiper.on('afterInit', boundUpdate);
    swiper.on('resize', boundUpdate);
    swiper.on('slideChange', boundUpdate);
    swiper.on('fromEdge', boundUpdate);
    swiper.on('reachBeginning', boundUpdate);
    swiper.on('reachEnd', boundUpdate);

    if (swiper.initialized) boundUpdate(); else swiper.on('init', boundUpdate);
    root[FLAG] = true;
  }

  function initAll(scope) {
    const roots = (scope || document).querySelectorAll('.kh-rel-coll');
    roots.forEach(initOne);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', (e) => initAll(e.target));
})();




//CONFIGURATORE MODAL

(function () {
  const overlay = document.getElementById('chs-config-modal');
  if (!overlay) return;

  const closeBtn = overlay.querySelector('.chs-config__close');
  const iframe = overlay.querySelector('.chs-config__frame');
  const openBtns = document.querySelectorAll('.chs__btn-config');

  function openConfigurator(url) {
    if (!url) return;
    iframe.removeAttribute('src'); // reset
    // set src on next frame to avoid jank
    requestAnimationFrame(() => { iframe.setAttribute('src', url); });
    overlay.setAttribute('aria-hidden', 'false');
    document.body.classList.add('chs-lock');
    closeBtn.focus();
  }

  function closeConfigurator() {
    overlay.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('chs-lock');
    // optional: unload to stop audio/script
    iframe.removeAttribute('src');
  }

  openBtns.forEach(btn => {
    btn.addEventListener('click', (e) => {
      const url = btn.getAttribute('data-config-url');
      openConfigurator(url);
    });
  });

  closeBtn.addEventListener('click', closeConfigurator);
  overlay.addEventListener('click', (e) => {
    if (e.target === overlay) closeConfigurator();
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeConfigurator();
  });
})();


(function(){
  const WRAP = '.complementary-list';
  const SELECT = '[data-variant-select]';
  const PRICE_WRAP = '[data-price-wrap]';
  const PRICE_NOW = '[data-price-now]';
  const PRICE_COMP = '[data-price-compare]';
  const BTN_ADD = '[data-add]';

  function getSelected(el){
    // el can be <select> or hidden input
    if(el.tagName === 'SELECT'){
      const opt = el.options[el.selectedIndex];
      if(!opt || !opt.value) return null;
      return {
        id: opt.value,
        price: opt.getAttribute('data-price'),
        priceRaw: Number(opt.getAttribute('data-price-raw') || 0),
        compare: opt.getAttribute('data-compare'),
        compareRaw: Number(opt.getAttribute('data-compare-raw') || 0),
        disabled: opt.disabled
      };
    } else {
      return {
        id: el.value,
        price: el.getAttribute('data-price'),
        priceRaw: Number(el.getAttribute('data-price-raw') || 0),
        compare: el.getAttribute('data-compare'),
        compareRaw: Number(el.getAttribute('data-compare-raw') || 0),
        disabled: false
      };
    }
  }

  function updatePrice(card){
    const sel = card.querySelector(SELECT);
    const priceBox = card.querySelector(PRICE_WRAP);
    const nowEl = card.querySelector(PRICE_NOW);
    const compEl = card.querySelector(PRICE_COMP);
    const btn = card.querySelector(BTN_ADD);

    if(!sel || !priceBox || !btn) return;
    const chosen = getSelected(sel);

    // se prodotto con select: prezzo nascosto finché non selezioni un valore valido
    // se hidden input (no taglia): mostra subito
    const hasSelect = sel.tagName === 'SELECT';

    if(!chosen || !chosen.id || (hasSelect && (!sel.value || sel.selectedIndex === 0 || chosen.disabled))){
      priceBox.hidden = true;
      btn.disabled = true;
      return;
    }

    nowEl.textContent = chosen.price || '';
    if(chosen.compareRaw > chosen.priceRaw){
      compEl.textContent = chosen.compare || '';
      compEl.hidden = false;
    } else {
      compEl.hidden = true;
    }
    priceBox.hidden = false;
    btn.disabled = false;
    btn.dataset.variantId = chosen.id;
  }

  async function addToCart(variantId){
    const fd = new FormData();
    fd.append('id', variantId);
    fd.append('quantity', 1);
    const r = await fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept':'application/json' } });
    if(!r.ok) throw new Error('add failed');
    return r.json();
  }

  document.addEventListener('change', (e)=>{
    const sel = e.target.closest(SELECT);
    if(!sel) return;
    const card = e.target.closest('.compL__item');
    if(card) updatePrice(card);
  });

  document.addEventListener('click', async (e)=>{
    const btn = e.target.closest(BTN_ADD);
    if(!btn) return;
    const card = btn.closest('.compL__item');
    const variantId = btn.dataset.variantId;
    if(!variantId){ return; }
    btn.disabled = true;
    try{
      await addToCart(variantId);
      // opzionale: feedback semplice
      btn.textContent = btn.getAttribute('data-done') || 'Aggiunto!';
      setTimeout(()=>{ btn.textContent = btn.getAttribute('data-label') || 'Aggiungi al carrello'; }, 1200);
    }catch(err){
      console.error(err);
    }finally{
      btn.disabled = false;
    }
  });

  function initCard(card){
    const btn = card.querySelector(BTN_ADD);
    if(btn){
      btn.setAttribute('data-label', btn.textContent.trim());
      btn.setAttribute('data-done', 'Aggiunto!');
    }
    updatePrice(card);
  }

  function initAll(){
    document.querySelectorAll(`${WRAP} .compL__item`).forEach(initCard);
  }

  if(document.readyState === 'complete' || document.readyState === 'interactive'){
    initAll();
  } else {
    document.addEventListener('DOMContentLoaded', initAll);
  }

  // product-recommendations può aggiornarsi dinamicamente: osserva e inizializza
  const pr = document.querySelector('product-recommendations');
  if(pr){
    const obs = new MutationObserver(()=> initAll());
    obs.observe(pr, { childList: true, subtree: true });
  }
})();



});
